import { Component, OnInit, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ADMIN_ROUTES, COACHES_ROUTES, CLIENTS_ROUTES, RATERS_ROUTES } from '../../sidebar/sidebar.component';
import { Location } from '@angular/common';
import { Router } from "@angular/router";
import { Globals } from "app/globals";
import { UserMenuComponent } from '../../user-menu/user-menu.component';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentEnum } from 'app/core/enums/environment-enum';
import { AdminService } from 'app/services/admin/AdminService';
import { CryptoJs } from '../crypto-js/crypto-js.component';
import { environment } from 'environments/environment';
// import { setTimeout } from 'timers';

@Component({
    // moduleId: module.id,
    selector: 'navbar-cmp',
    templateUrl: 'navbar.component.html',
    providers: [UserMenuComponent]
})

export class NavbarComponent implements OnInit{
    private adminTitles: any[];
    private coachesListTitles: any[];
    private clientsListTitles: any[];
    private ratersListTitles: any[];
    location: Location;
    //private toggleButton: any;
    //private sidebarVisible: boolean;

    fullName: String;
    availableModes: string[] = [];
    availableEnvironments =
        [{ value: EnvironmentEnum.Beta, label: 'Beta' },
         { value: EnvironmentEnum.Production, label: 'Production'}];
    showUserMenu: boolean = false;

    @ViewChild('userImage', {static: true}) userImage;
    @ViewChild('userMenu', {static: true}) userMenu;


    @HostListener('document:click', ['$event.target'])
    userImageOnClick(targetElement) {
        const userImageClickedInside = this.userImage.nativeElement.contains(targetElement);
        const userMenuClickedInside = this.userMenu.nativeElement.contains(targetElement);

        if (!userImageClickedInside && !userMenuClickedInside) {
            //console.log('CLICKED outside');
            if (this.showUserMenu) {
                this.showUserMenu = false;
            }

        }
    }

    constructor(
        location: Location,
        private element: ElementRef,
        public _Globals: Globals,
        private router: Router,
        public _CryptoJs: CryptoJs,
        private _UserMenuComponent: UserMenuComponent,
        public translate: TranslateService)
    {
        this.location = location;
        //this.sidebarVisible = false;
        this.fullName = this._Globals.getFullName();

        translate.addLangs(['en', 'fr']);
        translate.setDefaultLang('en');

        const browserLang = translate.getBrowserLang();
        translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
    }

    mouseleaveEvent() {
        //console.log($('.selectMode').hide());
        //setTimeout(() => {
        //    console.log($('.selectMode').show());
        //}, 100);
    }

    //ngAfterContentInit() {
    //    $(document).on('click', 'html', (e) => {
    //        console.log('CLICK', e);
    //        this.showUserMenu = false;
    //    });
    //}

    ngOnInit() {
        this.adminTitles = ADMIN_ROUTES.filter(listTitle => listTitle);
        this.coachesListTitles = COACHES_ROUTES.filter(listTitle => listTitle);
        this.clientsListTitles = CLIENTS_ROUTES.filter(listTitle => listTitle);
        this.ratersListTitles = RATERS_ROUTES.filter(listTitle => listTitle);
        const navbar: HTMLElement = this.element.nativeElement;
        this._Globals.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];

        //console.log('on init');
        var title = this.location.path();
        title = this.location.prepareExternalUrl(this.location.path());
        title = this.location.prepareExternalUrl(this.location.path());
        let result = title.split('/');
        title = result[2];
        //console.log('TITLE',title);
        //this.myGlobals.admin = this.containsObject(title, this.adminTitles);
        //this.myGlobals.coach = this.containsObject(title, this.coachesListTitles);
        //this.myGlobals.client = this.containsObject(title, this.clientsListTitles);
        //this.myGlobals.rater = this.containsObject(title, this.ratersListTitles);

        this.adminTitles.forEach((y) => {
            let match = y.find(x => x.path === title);
            if (match) {
                this._Globals.deactivateAllModes();
                this._Globals.admin = true;
                return;
            }
        });

        this.coachesListTitles.forEach((y) => {
            let match = y.find(x => x.path === title);
            if (match) {
                this._Globals.deactivateAllModes();
                this._Globals.coach = true;
                return;
            }
        });

        this.clientsListTitles.forEach((y) => {
            let match = y.find(x => x.path === title);
            if (match) {
                this._Globals.deactivateAllModes();
                this._Globals.client = true;
                return;
            }
        });


        if (title == 'rater_assessments') {
            this._Globals.deactivateAllModes();
            this._Globals.rater = true;
            return;
        }

        this.availableModes = this._Globals.getAvailableModes();

    }

    //ngAfterViewInit() {
    //    if ($(window).width() < 991) {
    //        console.log('ngAfterViewInit responsive');

    //        $('.main-panel .main-content').click(() => {
    //            console.log('MAIN-PANEL CLICKED');
    //            if (this._Globals.sidebarVisible == true) {
    //                this._Globals.sidebarVisible = false;
    //                $('body').removeClass('nav-open');
    //                $('.main-panel').css('margin-left', 0);
    //                this._Globals.toggleButton.classList.remove('toggled');
    //            }
    //        });
    //    }
    //}

    //containsObject(obj, list) {
    //    var i;
    //    for (i = 0; i < list.length; i++) {
    //        if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
    //            return true;
    //        }
    //    }
    //    return false;
    //}

    toggleUserMenu() {
        this._UserMenuComponent.toggleUserMenu();
    }


    sidebarOpen() {
        //const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(() => {
            //icon animation
            //this.toggleButton.classList.add('toggled');
        }, 500);
        //action open
        body.classList.add('nav-open');

        this._Globals.sidebarVisible = true;
    };

    sidebarClose() {
        const body = document.getElementsByTagName('body')[0];
        this._Globals.toggleButton.classList.add('toggled');
        setTimeout(() => {
            //icon animation
            this._Globals.toggleButton.classList.remove('toggled');
        }, 100);
        this._Globals.sidebarVisible = false;
        body.classList.remove('nav-open');
    };

    sidebarToggle() {
        // const toggleButton = this.toggleButton;
        // const body = document.getElementsByTagName('body')[0];
        if (this._Globals.sidebarVisible === false) {
            //close the user  menu if is open
            console.log('close user menu');
            $('.responsive-menu-wrap').removeClass('toogleMenu');
            $('.main-panel').css('margin-left', 225);
            $('.leftMenu-backdrop').css('right', 0);
            this.sidebarOpen();
        } else {
            this.sidebarClose();
            $('.main-panel').css('margin-left', 0);
            $('.leftMenu-backdrop').css('right', '-100%');
        }

    };

    logout() {
        //this._Globals.deactivateAllModes();
        this._Globals.isLoggedIn = false;
        this._Globals.selectedMode = undefined;
        this._Globals.clearAllAndRediretToLogin();
        //this.router.navigate(['login',]);
        //this._Globals.deleteAllStorage();
    }

    //write titles names in header
    //getTitle() {
    //    console.log("GET TITLE");
    //    //var titles = [];

    //    //if (this._Globals.admin) {
    //    //    titles = this.adminTitles;
    //    //    this._Globals.selectedMode = "admin";
    //    //}

    //    //if (this._Globals.coach) {
    //    //    titles = this.coachesListTitles;
    //    //    this._Globals.selectedMode = "coach";
    //    //}

    //    //if (this._Globals.client) {
    //    //    titles = this.clientsListTitles;
    //    //    this._Globals.selectedMode = "client";
    //    //}

    //    //if (this._Globals.rater) {
    //    //    titles = this.ratersListTitles;
    //    //    this._Globals.selectedMode = "rater";
    //    //}


    //      var titlee = this.location.path();
    //      var titlee = this.location.prepareExternalUrl(this.location.path());
    //      var titlee = this.location.prepareExternalUrl(this.location.path());
    //      let result = titlee.split('/');
    //      //titlee = titlee.split('/').pop();
    //      titlee = result[2];
    //      //for (var item = 0; item < titles.length; item++){
    //      //    for (var j = 0; j < titles[item].length; j++) {
    //      //        if (titles[item][j].path == titlee) {
    //      //            //this headerTitle is defined in sidebar.component.ts
    //      //            return titles[item][j].headerTitle;
    //      //        } else {
    //      //            //no menu pages (internal pages)
    //      //            switch (titlee) {
    //      //                case "edit_eli":
    //      //                    return "Edit Eli Assessment";

    //      //                case "neweli":
    //      //                    return "New Eli Assessment";

    //      //                case "newemailtemplate":
    //      //                case "edit_emailtemplate":
    //      //                case "new_coach_email_template":
    //      //                case "edit_coach_email_template": {
    //      //                    return "Template Email";
    //      //                }
    //      //                case "assigned_assessment":
    //      //                    return "Assessment";
    //      //                case "instructions":
    //      //                    return "Assessment Instructions"
    //      //            }
    //      //        }
    //      //    }

    //      //}
    //      //return '';
    //}

    //default redirect
    changeMode(mode: string) {
        console.log("change mode: ", mode);
        this.showUserMenu = false;

        this._Globals.deactivateAllModes();
        switch (mode) {
            case "Administrator":
            case "Manager":
                this._Globals.admin = true;
                localStorage.setItem("kUvPfGbd6J", this._CryptoJs.encrypt("Administrator", '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));

                if (this._Globals.getUserType() == "manager") {
                    this.router.navigate(['/app/admin_dashboard']);
                } else {
                    this.router.navigate(['/app/admin_dashboard']);
                }

                break;
            case "Coach":
                this._Globals.coach = true;
                localStorage.setItem("kUvPfGbd6J", this._CryptoJs.encrypt("Coach", '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this.router.navigate(['app/coach_home',]);
                break;
            case "Client":
                this._Globals.client = true;
                localStorage.setItem("kUvPfGbd6J", this._CryptoJs.encrypt("Client", '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this.router.navigate(['app/client_assessments',]);
                break;
            case "Rater":
                this._Globals.rater = true;
                localStorage.setItem("kUvPfGbd6J", this._CryptoJs.encrypt("Rater", '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                this.router.navigate(['app/rater_assessments',]);
                break;
        }


        setTimeout(() => {
            //setting active class for the first right menu item
            $('li.info').eq(0).addClass('active');
        }, 50);

        //console.log(this.myGlobals.coach);
        //this.myGlobals.coach = !this.myGlobals.coach;
        //if (this.myGlobals.coach) {
        //    this.router.navigate(['/assessments',]);
        //} else {
        //    this.router.navigate(['/niches',]);

        //}
    }

    public changeEnvironment(env: EnvironmentEnum): void {
        //console.log('get in changeEnvironment')
        const announcements = JSON.stringify(this._Globals.getAnnouncementsStatus());
        const token = encodeURIComponent(String(this._Globals.getToken()));
        const fullName = encodeURIComponent(String(this._Globals.getFullName()));
        const userId = encodeURIComponent(String(this._Globals.getUserId()));
        const userType = encodeURIComponent(String(this._Globals.getUserType()));
        const mode = encodeURIComponent(String(this._Globals.getMode()));
        const modes = encodeURIComponent(JSON.stringify(this._Globals.getAvailableModes()));
        const userEmail = encodeURIComponent(String(this._Globals.getUserEmail()));
        const userCanEditEmail = encodeURIComponent(String(this._Globals.getCanUserEditEmail()));
        const userIsStudent = encodeURIComponent(String(this._Globals.getIsUserStudent()));
        const hasBetaAccess = encodeURIComponent(String(this._Globals.hasBetaAccess()));

        //console.log(announcements);
        //console.log(token);
        //console.log(fullName);
        //console.log(userId);
        //console.log(userType);
        //console.log(mode);
        //console.log(modes);
        //console.log(userEmail);
        //console.log(userCanEditEmail);
        //console.log(userIsStudent);
        //console.log(hasBetaAccess);

        switch(Number(env)) {
            case EnvironmentEnum.Beta:
                window.location.href = `${environment.betaEnvironmentURL}/changeEnvironment/${announcements}/${token}/${fullName}/${userId}/${userType}/${mode}/${modes}/${userEmail}/${userCanEditEmail}/${userIsStudent}/${hasBetaAccess}/${env}`;

                break;
            case EnvironmentEnum.Production:
                window.location.href = `${environment.productionEnvironmentURL}/changeEnvironment/${announcements}/${token}/${fullName}/${userId}/${userType}/${mode}/${modes}/${userEmail}/${userCanEditEmail}/${userIsStudent}/${hasBetaAccess}/${env}`;

                break;
        }

        // logout
        this._Globals.isLoggedIn = false;
        this._Globals.selectedMode = undefined;
        this._Globals.deleteAllStorage();
        this._Globals.deactivateAllModes();
        this._Globals.invitationLinkFrom = '';
    }

}
